import { sha256 } from '@noble/hashes/sha256';

/**
 * Compute SHA-256 hash of a string.
 * Returns 32-byte Uint8Array matching the Rust `hashv(&[title.as_bytes()])` seed derivation.
 */
export function sha256Hash(input: string): Uint8Array {
  return sha256(input);
}
